module.exports = __webpack_public_path__ + "img/default.9781880b.png";